<div class="cm-table-container mat-elevation-z8">
    <table #revisionTableRef mat-table [dataSource]="$template().revisions">
        <!-- Revision column -->
        <ng-container matColumnDef="revision">
            <th mat-header-cell *matHeaderCellDef>Revision</th>
            <td mat-cell *matCellDef="let revision; table: $revisionTable()">
                <div class="cm-revision-number-container">
                    <ng-container>{{ revision.number }}</ng-container>
                    <a
                        class="cm-revision-action"
                        [class.cm-disabled]="!$canEditRevision()"
                        (click)="$canEditRevision() && openRevision(revision)"
                        [matTooltip]="$canEditRevision() ? 'Open' : 'You do not have permission to edit this template'"
                        matTooltipPosition="above"
                    >
                        <i class="far fa-edit"></i> </a
                    ><a
                        class="cm-revision-action"
                        [class.cm-disabled]="!$canDeleteRevision()"
                        (click)="$canDeleteRevision() && deleteRevision(revision)"
                        [matTooltip]="$canDeleteRevision() ? 'Delete' : 'You do not have permission to delete this revision'"
                        matTooltipPosition="above"
                    >
                        <i class="far fa-trash"></i>
                    </a>
                </div>
            </td>
        </ng-container>
        <!-- Author column -->
        <ng-container matColumnDef="author">
            <th mat-header-cell *matHeaderCellDef>Author</th>
            <td mat-cell *matCellDef="let revision; table: $revisionTable()">{{ revision.createdBy?.firstName }} {{ revision.createdBy?.lastName }}</td>
        </ng-container>
        <!-- Date column -->
        <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef>Date</th>
            <td mat-cell *matCellDef="let revision; table: $revisionTable()">
                <span matTooltip="{{ revision.createdAt | cmFormatDate }}" matTooltipPosition="above">{{ revision.createdAt | cmTimeAgo }}</span>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
</div>
